@if (globtroterMenuConfig(); as menuConfig) {
  <div class="flex justify-center bg-gray-200 pt-[13px] mb-[14px]">
    <nav class="flex justify-between px-4 pt-4 w-full h-36">
      @switch (globtroterConfig()?.theme) {
        @case ('polisy') {
          <img class="h-12 mb-6" src="./mondial-logo.png" />
        }
        @case ('globtroter') {
          <img class="h-12 mb-6" src="./allianz-logo.svg" />
        }
      }
      @if (isMobileView$ | async) {
        <div>
          <button nxIconButton="secondary" type="button" (click)="openModal()">
            <nx-icon name="bars" aria-hidden="true"></nx-icon>
          </button>
        </div>
      } @else {
        <div class="flex flex-col items-end">
          <div class="flex items-baseline gap-6">
            <a [href]="'/' + globtroterApp + staticGlobtroterPaths.news">
              <nx-icon name="bell" size="s" class="text-zinc-500 hover:text-zinc-600 cursor-pointer" />
            </a>
            @if (globtroterUser()?.user; as user) {
              <div
                [nxContextMenuTriggerFor]="userMenu"
                class="flex gap-2 cursor-pointer items-center border border-zinc-500 bg-zinc-100 hover:bg-zinc-200 p-2 px-8"
                >
                <nx-icon name="user" size="s" class="text-zinc-500" />
                <p class="font-semibold text-lg">{{ user.firstName }} {{ user.lastName }}</p>
                <nx-icon name="chevron-down-small" size="s" />
              </div>
            }
            <nx-context-menu #userMenu="nxContextMenu">
              <button nxContextMenuItem type="button">
                <a [href]="'/' + globtroterApp + staticGlobtroterPaths.userProfile">{{ 'globtroter-menu.user-profile' | translate }}</a>
              </button>
              <button nxContextMenuItem type="button">
                <a [href]="'/' + globtroterApp + staticGlobtroterPaths.changePassword">{{ 'globtroter-menu.change-password' | translate }}</a>
              </button>
              <button nxContextMenuItem type="button">
                <a [href]="'/' + globtroterApp + staticGlobtroterPaths.logout">{{ 'globtroter-menu.logout' | translate }}</a>
              </button>
            </nx-context-menu>
          </div>
          <div nx-header class="flex !items-end !border-0 !pr-0 !bg-transparent">
            <nx-header-navigation>
              @for (item of menuConfig.result; track item) {
                <nx-header-navigation-item>
                  <div>
                    @switch (item.type) {
                      @case ('menu') {
                        <a nxHeaderLink class="!mr-6" [nxContextMenuTriggerFor]="menu">
                          <div class="flex items-center cursor-pointer">
                            <p>{{ item.label }}</p>
                            <nx-icon name="chevron-down-small" size="s" />
                          </div>
                        </a>
                      }
                      @case ('link') {
                        <a nxHeaderLink class="!mr-6" [href]="(item.isSpaLink ? '/' + globtroterApp : '') + item.link">{{
                          item.label
                        }}</a>
                      }
                    }
                  </div>
                  <nx-context-menu #menu="nxContextMenu">
                    @for (subItem of item.items; track subItem) {
                      <button nxContextMenuItem type="button">
                        <a [href]="(subItem.isSpaLink ? '/' + globtroterApp : '') + subItem.link">{{ subItem.label }}</a>
                      </button>
                    }
                  </nx-context-menu>
                </nx-header-navigation-item>
              }
            </nx-header-navigation>
          </div>
        </div>
      }
    </nav>
  </div>
}
